package org.solyton.solawi.bid.module.banking.component.modal.sepa

import androidx.compose.runtime.*
import org.evoleq.compose.Markup
import org.evoleq.compose.modal.Modal
import org.evoleq.compose.modal.ModalData
import org.evoleq.compose.modal.ModalType
import org.evoleq.compose.modal.Modals
import org.evoleq.compose.style.data.device.DeviceType
import org.evoleq.language.Lang
import org.evoleq.math.Source
import org.evoleq.optics.storage.Storage
import org.evoleq.optics.storage.nextId
import org.evoleq.optics.storage.put
import org.jetbrains.compose.web.css.marginLeft
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.ElementScope
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Text
import org.solyton.solawi.bid.application.ui.page.application.style.listItemWrapperStyle
import org.solyton.solawi.bid.module.banking.component.list.sepa.OverAllActionData
import org.solyton.solawi.bid.module.banking.component.list.sepa.SepaPaymentListItemKey
import org.solyton.solawi.bid.module.list.component.*
import org.solyton.solawi.bid.module.scrollable.Scrollable
import org.solyton.solawi.bid.module.style.modal.commonModalStyles
import org.solyton.solawi.bid.module.style.wrap.Wrap
import org.w3c.dom.HTMLElement


@Markup
@Suppress("FunctionName")
fun MoveFailedPaymentsModal(
    id: Int,
    parentModalId: Int,
    texts: Lang.Block,
    modals: Storage<Modals<Int>>,
    device: Source<DeviceType>,
    isDataValid:  ()->Boolean,
    data: OverAllActionData,
    setData: (OverAllActionData) -> Unit,
    update: ()->Unit
): @Composable ElementScope<HTMLElement>.()->Unit = Modal(
    type = ModalType.Child<Int>(parentModalId),
    id = id,
    modals = modals,
    device = device,
    onOk = {
        update()
    },
    onCancel = {},
    texts = texts,
    styles = commonModalStyles(device).modifyContainerStyle {
        width(80.percent)
        marginLeft(5.percent)
    },
    isOkButtonDisabled = { !isDataValid() }
) {
    var dataState by remember { mutableStateOf(data) }

    val selectedPayments by derivedStateOf { dataState.itemsMap.filter {
        it.key in dataState.visibleItems &&
        dataState.checkedPayments[it.key.paymentId] == true
    }.values.toList() }



    Wrap {
        ListWrapper() {
            TitleWrapper{ Title { H2 { Text("List of failed payments") }}}

            HeaderWrapper {
                Header {
                    HeaderCell("Debtor"){ width(20.percent)}
                    HeaderCell("Amount"){ width(10.percent)}
                    HeaderCell("Failure Reason"){ width(60.percent)}
                }
            }
            Scrollable {
                ListItemsIndexed(selectedPayments) { index, item ->
                    ListItemWrapper({listItemWrapperStyle(index)}) {
                        DataWrapper {
                            TextCell(item.mandate.debtorName) { width(20.percent) }
                            TextCell("${item.payment.amount}") { width(10.percent) }
                            EditableTextCell(item.payment.failureReason ?: "", style = { width(60.percent) }) { newValue ->
                                val key = SepaPaymentListItemKey(item.payment.sepaPaymentId, item.payment.sepaMandateId)
                                val newMap = dataState.itemsMap.toMutableMap()
                                newMap[key] = item.copy(payment = item.payment.copy(failureReason = newValue.ifBlank { null }))
                                dataState = dataState.copy(
                                    itemsMap = newMap,
                                )
                                setData(dataState)
                            }
                        }
                    }
                }
            }
        }
    }
}

@Markup
fun Storage<Modals<Int>>.showMoveFailedPaymentsModal(
    parentModalId: Int,
    texts: Lang.Block,
    device: Source<DeviceType>,
    isDataValid:  ()->Boolean,
    data: OverAllActionData,
    setData: (OverAllActionData) -> Unit,
    update: ()->Unit
) = with(nextId()) {
    put(this to ModalData(this,
        ModalType.Child<Int>(parentModalId),
        MoveFailedPaymentsModal(
            id = this,
            parentModalId = parentModalId,
            texts = texts,
            modals = this@showMoveFailedPaymentsModal,
            device = device,
            isDataValid = isDataValid,
            data = data,
            setData = setData,
            update = update
        )
    ) )
}
